import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
    return (
        <div className="tc-container">
            <h1 className="tc-title">Terms & Conditions</h1>

            <section className="tc-section">
                <h2>1. Legal Acceptance & Binding Agreement</h2>
                <p>
                    By accessing, browsing, registering, or placing an order on this website,
                    the user (“Customer”, “You”) agrees to be bound by these Terms & Conditions
                    and all related policies.
                </p>
                <p>
                    This forms a legally binding agreement between the Customer and Sharon
                    Telematics Private Limited (“Way4Track”, “Company”, “We”, “Us”) in
                    accordance with applicable Indian laws.
                </p>
                <p>
                    The Company maintains system-generated records such as IP address,
                    timestamps, and logs which may be used as legal evidence.
                </p>
            </section>

            <section className="tc-section">
                <h2>2. Eligibility & Legal Capacity</h2>
                <ul>
                    <li>Must be at least 18 years old</li>
                    <li>Must be legally capable of entering a contract</li>
                    <li>Information provided must be accurate</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>3. Order Lifecycle & Legal Status</h2>
                <p>PLACED → CONFIRMED → SHIPPED → DELIVERED</p>
                <ul>
                    <li>PLACED: Payment completed</li>
                    <li>CONFIRMED: Approved by company</li>
                    <li>SHIPPED: Dispatched</li>
                    <li>DELIVERED: Completed with POD</li>
                </ul>
                <p>
                    Cancellation is allowed only before confirmation. Once confirmed,
                    cancellation is not permitted.
                </p>
            </section>

            <section className="tc-section">
                <h2>4. Payment Terms & Fraud Control</h2>
                <p>All transactions are 100% prepaid via secure payment gateways.</p>
                <ul>
                    <li>Orders may undergo verification</li>
                    <li>Suspicious transactions may be cancelled</li>
                    <li>Refunds apply only before confirmation</li>
                </ul>
                <p>
                    Payment gateway charges may be deducted in case of cancellations.
                </p>
            </section>

            <section className="tc-section">
                <h2>5. Finality of Confirmed Orders</h2>
                <p>
                    Once confirmed, orders cannot be cancelled or refunded due to inventory
                    and logistics commitments.
                </p>
            </section>

            <section className="tc-section">
                <h2>6. Pricing, GST & Financial Structure</h2>
                <ul>
                    <li>Prices include GST</li>
                    <li>Invoices generated after dispatch</li>
                    <li>Discounts cannot be changed later</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>6A. Coupons, Offers & Discounts</h2>
                <ul>
                    <li>Coupons are non-transferable</li>
                    <li>Cannot be exchanged for cash</li>
                    <li>Refunds only include actual paid amount</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>7. Shipping & Delivery Terms</h2>
                <p>
                    Shipping charges vary based on order. Incorrect address may lead to
                    re-shipping charges without refund.
                </p>
            </section>

            <section className="tc-section">
                <h2>8. Delivery & Proof of Delivery (POD)</h2>
                <p>
                    Delivery is complete upon POD including OTP, signature, or
                    acknowledgment.
                </p>
            </section>

            <section className="tc-section">
                <h2>9. Damage Reporting</h2>
                <p>
                    Report damages within 24 hours with evidence. Late claims may not be
                    accepted.
                </p>
            </section>

            <section className="tc-section">
                <h2>10. Installation & Warranty</h2>
                <p>
                    Improper installation may void warranty.
                </p>
            </section>

            <section className="tc-section">
                <h2>11. Prohibited Use</h2>
                <ul>
                    <li>No unauthorized tracking</li>
                    <li>No privacy violations</li>
                    <li>No unlawful activities</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>12. GPS Device Liability Disclaimer</h2>
                <p>
                    Company is not responsible for usage after delivery.
                </p>
            </section>

            <section className="tc-section">
                <h2>13. Indemnity</h2>
                <p>
                    Customer agrees to indemnify the company against misuse or violations.
                </p>
            </section>

            <section className="tc-section">
                <h2>14. Limitation of Liability</h2>
                <p>
                    Liability limited to product value. No responsibility for indirect
                    losses.
                </p>
            </section>

            <section className="tc-section">
                <h2>15. Force Majeure</h2>
                <p>
                    Company not liable for events beyond control.
                </p>
            </section>

            <section className="tc-section">
                <h2>16. Dispute Resolution & Jurisdiction</h2>
                <p>
                    Disputes subject to arbitration under Indian law, jurisdiction:
                    Visakhapatnam, Andhra Pradesh.
                </p>
            </section>
        </div>
    );
};

export default TermsAndConditions;
